import { graphql } from 'gatsby'
import React, { FC } from 'react'
import Head from '../components/Head'
import Layout from '../components/layout'
import Pagination from '../components/Pagination'
import Widget from '../components/widget'
import { getGatsbyImage } from '../helpers/processImages'
import { AllFileQueryI, AllMarkdownRemarkI, PaginationContextI } from '../types/common'
import { SiteMetadataI, PostI } from '../types/data-models'

const MAX_PAGES = 8
interface PostCollectionI {
  data: {
    site: {
      siteMetadata: SiteMetadataI
    }
    posts: AllMarkdownRemarkI<PostI>
    thumbnails: AllFileQueryI
  }
  location: Location
  pageContext: PaginationContextI
}

const PostCollection: FC<PostCollectionI> = ({ data, location, pageContext }) => {
  const { currentPage, totalPages } = pageContext
  const allThumbnails = data.thumbnails

  return (
    <Layout data={data} location={location} isSinglePost={false}>
      <Head />
      {data.posts.nodes.map((item) => (
        <Widget
          key={item.fields.slug}
          post={item}
          thumbnail={
            item.frontmatter.coverImage?.url
              ? getGatsbyImage(item.frontmatter.coverImage?.url, allThumbnails)
              : undefined
          }
        />
      ))}
      <Pagination currentPage={currentPage} totalPages={totalPages} maxPages={MAX_PAGES} />
    </Layout>
  )
}

export default PostCollection

export const query = graphql`
  query($skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
        description
        logo
        social {
          twitter
          facebook
          snapchat
          instagram
          medium
        }
        menuLinks {
          label
          url
        }
        contact {
          info
          email
          tel
          address
        }
      }
    }
    posts: allMarkdownRemark(
      filter: { fields: { type: { eq: "POST" } }, frontmatter: { isDraft: { eq: false } } }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        excerpt
        fields {
          slug
          type
        }
        frontmatter {
          title
          subtitle
          coverImage {
            label
            url
          }
        }
      }
    }
    thumbnails: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
      edges {
        node {
          relativePath
          sourceInstanceName
          childImageSharp {
            gatsbyImageData(width: 480, quality: 100, placeholder: BLURRED)
          }
          publicURL
        }
      }
    }
  }
`
